module.exports = __webpack_public_path__ + "static/media/servisAkademi.316dfa46.png";